import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/personas',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/password-recovery',
    name: 'password-recovery',
    component: () => import(/* webpackChunkName: "about" */ '../components/CompRecuperarContraseña.vue')
  }, 

  {
    path: '/empresas',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
  },
  {
    path: '/hojadevida',
    name: 'hojadevida',
    component: () => import(/* webpackChunkName: "about" */ '../views/HojaVida.vue')
  },
  {
    path: '/hojadevidareclutador',
    name: 'hojadevidareclutador',
    component: () => import(/* webpackChunkName: "about" */ '../views/HojaVidaReclutador.vue')
  },
  {
    path: '/curriculo',
    name: 'curriculo',
    component: () => import(/* webpackChunkName: "about" */ '../views/Curriculum.vue')
  },
  {
    path: '/reclutadores',
    name: 'reclutadores',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reclutadores.vue')
  },
  {
    path: '/areapersona',
    name: 'areapersona',
    component: () => import(/* webpackChunkName: "about" */ '../views/AreaPersona.vue')
  },
  {
    path: '/reclutadores',
    name: 'reclutadores',
    component: () => import(/* webpackChunkName: "about" */ '../views/Reclutadores.vue')
  },
  {
    path: '/registroempresa',
    name: 'registroempresa',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegistroEmpresa.vue')
  },
  {
    path: '/ofertaslaborales',
    name: 'ofertaslaborales',
    component: () => import(/* webpackChunkName: "about" */ '../views/OfertasLaborales.vue')
  },
  {
    path: '/filtroOfertas',
    name: 'filtroOfertas',
    component: () => import(/* webpackChunkName: "about" */ '../views/OfertasFiltro.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin.vue')
  },
  {
    path: '/UploadFileRethus',
    name: 'UploadFileRethus',
    component: () => import(/* webpackChunkName: "about" */ '../views/UploadFileRethus.vue')
  },
  {
    path: '/upload',
    name: 'upload',
    component: () => import(/* webpackChunkName: "about" */ '../views/VerificacionOfertas.vue')
  },
  {
    path: '/ConsultaCandidatos',
    name: 'ConsultaCandidatos',
    component: () => import(/* webpackChunkName: "about" */ '../views/ConsultaCandidatos.vue')
  },
  {
    path: '/Planes',
    name: 'Planes',
    component: () => import(/* webpackChunkName: "about" */ '../views/Planes.vue')
  },
  {
    path: '/Basico',
    name: 'Basico',
    component: () => import(/* webpackChunkName: "about" */ '../views/PlanBasico.vue')
  } 
  ,
  {
    path: '/Estandar',
    name: 'Estandar',
    component: () => import(/* webpackChunkName: "about" */ '../views/Estandar.vue')
  } 
  ,
  {
    path: '/FormularioPagos',
    name: 'FormularioPagos',
    component: () => import(/* webpackChunkName: "about" */ '../components/FormularioPagos.vue')
  },
  {
    path: '/FormularioResponsePagos',
    name: 'FormularioResponsePagos',
    component: () => import(/* webpackChunkName: "about" */ '../views/FormularioResponsePagos.vue')
  },
  {
    path: '/pago/respuesta',
    name: 'PaymentResponse',
    component: () => import(/* webpackChunkName: "about" */ '../views/PaymentResponse.vue')
  },
  {
    path: '/ResetPassword',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/ResetPassword.vue')
  }


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
